import { CUSTODY_LOGOS, KRAKEN_LOGO } from '@/lib/custody'
import { CUSTODY_LABELS, type Custody } from '@/lib/pool'

/**
 * Sonar's, Binance's, MEXC's or Coinbase's mark, round like a token logo.
 * MEXC's is a bare glyph on no background, and its file is cropped to that
 * glyph: it is left unrounded so the circle clip does not cut its legs and
 * carries no margin of its own, so it lines up with the round marks in a
 * column (John, Nov 1 2026: "mexc is the one misaligned logo").
 */
export function CustodyLogo({ custody, size = 'size-4', className = '' }: { custody: Custody; size?: string; className?: string }) {
  const shape = custody === 'mexc' ? '' : 'rounded-full'
  return <img src={CUSTODY_LOGOS[custody]} alt="" className={`${size} shrink-0 ${shape} object-contain ${className}`} />
}

export type Platform = 'wallet' | 'sonar' | 'binanceus' | 'mexc' | 'coinbase' | 'vault' | 'kraken'

/** Where a transaction happened (John, Oct 31 2026): the trading wallet itself, Sonar's pool, an exchange, or the account's own vault (Nov 1 2026); the logo alone. */
export function PlatformLogo({ platform, size = 'size-5' }: { platform: Platform; size?: string }) {
  if (platform === 'wallet') return <img src="/brand/logo-tile.png" alt="Wallet" title="Wallet" className={`${size} shrink-0 rounded-md`} />
  if (platform === 'vault') return <img src="/brand/logo-tile.png" alt="Vault" title="Vault" className={`${size} shrink-0 rounded-md`} />
  if (platform === 'kraken') return <img src={KRAKEN_LOGO} alt="Kraken" title="Kraken" className={`${size} shrink-0 object-contain`} />
  return <span title={CUSTODY_LABELS[platform]}><CustodyLogo custody={platform} size={size} /></span>
}
